// sessionStorage key written by GoogleOneTap when a One Tap sign-in creates a NEW lead and
// read by OneTapWelcomeBanner. sessionStorage is per tab, so the banner lasts the tab session.
export const ONE_TAP_NEW_LEAD_KEY = 'one_tap_new_lead';
